import { HttpClient } from "@angular/common/http";
import { inject, Injectable, SecurityContext } from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { environment } from "@environments/environment";
import { notNull } from "@ubisolutions/base/utils";
import { catchError, filter, map, Observable, of, switchMap, tap } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class ProtectedAssetsService {
    private readonly http = inject(HttpClient);

    public getProtectedFile(uuid: string): Observable<Blob> {
        return this.http.get(
            `${environment.api.resourceFileUrl}/${uuid}/download`,
            { responseType: "blob" }
        );
    }

    public getProtectedUrl(fileName: string): Observable<string> {
        return this.getProtectedFile(fileName).pipe(
            map((blob) => {
                return URL.createObjectURL(blob);
            }),
        );
    }
}
